import { PhotographIcon } from "@heroicons/react/solid";
import React, { useEffect, useState } from "react";

const personalPhotos = [
  {
    photo: "./slideshow/alps.jpg",
    caption: "Exploring the Swiss Alps during a winter trip to central Europe."
  },
  {
    photo: "./slideshow/EstesPark.jpg",
    caption: "Adventuring at Estes Park in the Colorado Rocky Mountains."
  },
  {
    photo: "./slideshow/golden_gate.jpg",
    caption: "Biking to & across the Golden Gate Bridge in San Francisco, California."
  },
  {
    photo: "./slideshow/Teddie2.jpg",
    caption: "Exploring the nation's capital with a family member's dog, Teddie."
  },
  {
    photo: "./slideshow/waymo.jpg",
    caption: "Testing out Waymo's self-driving car technology in San Francisco, California."
  },
  {
    photo: "./slideshow/boston_kayak.jpg",
    caption: "Kayaking on the Charles River in Boston, Massachusetts."
  },
  {
    photo: "./slideshow/beach_bike.jpg",
    caption: "Biking on the rocky cliffs of Ocean Beach, California."
  },
  {
    photo: "./slideshow/honey_island.jpg",
    caption: "Exploring the Honey Island Swamp near New Orleans, Louisiana."
  },
  {
    photo: "./slideshow/tallinn.jpg",
    caption: "Enjoying the charming medieval architecture of Tallinn, Estonia."
  },
  {
    photo: "./slideshow/cincinnati.jpg",
    caption: "Standing on a hill overlooking Cincinnati, Ohio."
  },
  {
    photo: "./slideshow/louisville.jpg",
    caption: "Enjoying a beautiful sunset over the Ohio River in Louisville, Kentucky."
  },
  {
    photo: "./slideshow/pittsburgh.jpg",
    caption: "Standing on a hill overlooking Pittsburgh, Pennsylvania."
  },
  {
    photo: "./slideshow/susquehanna.jpg",
    caption: "Camping in the beautiful green woods of Susquehanna State Park in Maryland."
  },
  {
    photo: "./slideshow/mission_trails.jpg",
    caption: "Hiking North Fortuna Mountain at Mission Trails in San Diego, California."
  },
  {
    photo: "./slideshow/delmar_bike.jpg",
    caption: "Bicycling in Del Mar, California as part of a 44-mile ride from La Mesa to Oceanside."
  },
];

export default function AboutPage() {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen py-10 lg:py-20">
      <div className="container px-5 mx-auto text-center lg:px-10">
        <PhotographIcon className="mx-auto inline-block w-10 mb-4 text-gray-700 dark:text-gray-400" />
        <h1 className="sm:text-5xl text-4xl font-medium title-font mb-4 text-gray-900 dark:text-white">
          Outside the Lab
        </h1>
        <p className="lg:w-2/3 mx-auto leading-relaxed text-lg text-gray-700 dark:text-gray-400 mb-12">
          When I'm not working on research or leading student organizations, 
          I enjoy exploring the outdoors, traveling to new places, and spending time with family and friends.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:w-[90%] mx-auto">
          {personalPhotos.map((item, index) => (
            <div 
              key={index} 
              className="relative group cursor-pointer overflow-hidden rounded-xl shadow-lg"
              onClick={() => setSelectedPhoto(item)}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  setSelectedPhoto(item);
                }
              }}
              tabIndex={0}
              role="button"
              aria-label={`View larger image: ${item.caption}`}
            >
              <div className="w-full relative transition-transform duration-300 group-hover:scale-110" style={{ paddingTop: 'calc(100% / 1.55)' }}>
                <img
                  src={item.photo}
                  alt={item.caption}
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-60 transition-opacity duration-300 flex items-end p-4">
                <p className="text-white text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {item.caption}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedPhoto && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedPhoto(null)}
          onKeyPress={(e) => {
            if (e.key === 'Escape') {
              setSelectedPhoto(null);
            }
          }}
          role="dialog"
          aria-modal="true"
          aria-label="Image preview"
        >
          <div className="relative max-w-5xl max-h-full">
            <button
              onClick={() => setSelectedPhoto(null)}
              className="absolute top-4 right-4 text-white text-4xl font-bold hover:text-gray-300 focus:outline-none focus:ring-2 focus:ring-white rounded-full w-12 h-12 flex items-center justify-center"
              aria-label="Close preview"
            >
              &times;
            </button>
            <div style={{ width: 'min(90vw, 1200px)' }} className="mx-auto">
              <div className="relative mx-auto" style={{ paddingTop: 'calc(100% / 1.55)' }}>
                <img
                  src={selectedPhoto.photo}
                  alt={selectedPhoto.caption}
                  className="absolute inset-0 w-full h-full object-cover rounded-lg"
                />
              </div>
            </div>
            <p className="text-white text-center mt-4 text-lg">
              {selectedPhoto.caption}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
